import { render } from "./Table.vue?vue&type=template&id=23f73a30&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=23f73a30&lang=scss&scoped=true"
import "./Table.vue?vue&type=style&index=1&id=23f73a30&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f73a30"]])

export default __exports__